module.exports = __webpack_public_path__ + "img/125.2.652cf22c.png";